import axiosInstance from "./../../utils/axiosInstance";
import { buildQueryParams } from './../../services/utility';

const getUsers = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`user?${queryString}`);
  return response.data.data;
};

const getUser = async (params) => {
  const response = await axiosInstance.get(`user/${params}`);
  return response.data.data;
};

const updateUsersStatus = async (params) => {
  const response = await axiosInstance.put(`user/${params.id}`, params.data);
  return response.data.data;
};

const getDashboardData = async () => {
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  
  const utcStartDate = startDate.toISOString();
  const utcEndDate = endDate.toISOString();
  
  const response = await axiosInstance.get(`dashboard?start_date=${utcStartDate}&end_date=${utcEndDate}`);
  return response.data.data;
};

const getLeaderboardData = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`dashboard/leaderboard?${queryString}`);
  return response.data.data;
};

const changeUserPassword = async ({ id, password }) => {
  const response = await axiosInstance.put(`user/${id}/password`, { password });
  return response.data.data;
};

const customerService = {
  getUsers,
  updateUsersStatus,
  getDashboardData,
  getLeaderboardData,
  getUser,
  changeUserPassword,
};

export default customerService;
